import styled from '../../../config/theme'

const Input = styled.input<{ icon?: boolean }>`
  background: ${props => props.theme.forms.fields.background};
  color: ${props => props.theme.color.darkGray};
  border: 1px solid ${props => props.theme.forms.fields.border};

  font-size: ${props => props.theme.fontSize.regular};
  border: 1px solid ${props => props.theme.color.lightGray};
  border-radius: 4px;
  padding: 8px 16px;

  // width: 100%;

  &::placeholder {
    color: ${props => props.theme.color.placeholder};
    font-style: ${props => props.theme.forms.fields.placeholderFormStyle};
    opacity: 1;
  }
`

const Select = styled.select`
  font-size: ${props => props.theme.fontSize.regular};
  border: 1px solid ${props => props.theme.color.lightGray};
  color: ${props => props.theme.color.darkGray};
  border-radius: 4px;
  padding: 8px 16px;
  position: relative;

  appearance: none;

  background: white;

  + span {
    content: '';
    position: absolute;
    z-index: 2;
    right: 24px;
    top: 50%;
    margin-top: -3px;
    height: 0;
    width: 0;
    border-top: 6px solid #414141;
    border-left: 6px solid ${props => props.theme.color.transparent};
    border-right: 6px solid ${props => props.theme.color.transparent};
    pointer-events: none;
  }
`

const TextArea = styled.textarea`
  font-size: ${props => props.theme.fontSize.regular};
  border: 1px solid ${props => props.theme.color.lightGray};
  border-radius: 4px;
  padding: 8px 16px;
  box-sizing: border-box;

  min-height: 42px;
  height: 160px;

  resize: vertical;

  &::placeholder {
    color: ${props => props.theme.color.lightGray};
    font-style: italic;
  }
`

const Label = styled.label`
  margin-bottom: 5px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  text-align: left;
  color: ${props => props.theme.forms.label};
`

const Error = styled.span`
  color: ${props => props.theme.forms.error};
  font-size: ${props => props.theme.fontSize.hint};
  position: absolute;
  bottom: -3px;
`

const File = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 5px 0;

  > button {
    justify-self: flex-end;
  }
`

const FileName = styled.a`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 10px;
  text-decoration: none;
  color: ${props => props.theme.color.bluishGray};
`

const AvatarButton = styled.div`
  height: 125px;
  width: 125px;
  background: white;
  border: 1px solid ${props => props.theme.color.lightGray};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  cursor: pointer;
`

const AvatarImage = styled.div`
  height: 125px;
  width: 125px; 
  background: white;
  border: 1px solid ${props => props.theme.color.lightGray};
  border-radius: 50%;
  margin: auto;
  position: relative;
  cursor: pointer;

  &:hover:before {
    content: 'TROCAR';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 50%;
    font-weight: bold;
  }

  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`

const PasswordRevealButton = styled.button`
  position: absolute;
  right: 10px;
  bottom: 11px;
  height: 37px;
  width: 37px;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;

  > img {
    height: 20px;
  }
`

const FieldIcon = styled.div`
  position: absolute;
  left: 10px;
  bottom: 11px;
  height: 37px;
  width: 37px;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  + * {
    padding-left: 36px;
  }
`

export { Label, Select, TextArea, Input, Error, File, FileName, AvatarButton, AvatarImage, PasswordRevealButton, FieldIcon, }

